import React from 'react';
import AppRouter from './router/AppRouter';
import { store } from './store';
import { Provider } from 'react-redux';
import 'modern-normalize';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "stream-chat-react/dist/css/v2/index.css";
import "@stream-io/video-react-sdk/dist/css/styles.css";
import './App.css';
import Modal from 'react-modal';
import ConfirmModal from './components/ConfirmModal';
import { useAuth } from './hooks/useAuth';
import { AuthenticationStatus } from './store/slices/authSlice';
import Loader from './pages/chat/components/Loader';
import ConnectDialog from './components/ConnectDialog';
import { useApp } from './hooks/useApp';
import { Repository } from './repositories/Repository';
import OtpDialog from './components/OtpDialog';
import StreamContainer from './pages/chat/components/StreamContainer';
import HouseRulesModal from './components/HouseRulesModal';
import LinkInterceptor from './components/LinkInterceptor';
import { getAllRedirectRules } from './config/linkRedirects';

Modal.setAppElement('#root');
Repository.init();

// Primary Domain Redirect
const primaryDomain = import.meta.env.VITE_PRIMARY_DOMAIN;
if (primaryDomain && primaryDomain.trim() !== '') {
  const currentHost = window.location.host;
  const isLocalhost = currentHost.includes('localhost') || currentHost.includes('127.0.0.1');
  
  if (!isLocalhost && currentHost !== primaryDomain) {
    const newUrl = window.location.protocol + '//' + primaryDomain + window.location.pathname + window.location.search + window.location.hash;
    window.location.replace(newUrl);
  }
}

const App: React.FC = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <AppWrapper />
      </Provider>
    </React.StrictMode>
  );
};

const AppWrapper = () => {
  const { status } = useAuth();
  useApp();
  const redirectConfig = getAllRedirectRules();

  if(status !== AuthenticationStatus.INITIAL && status !== AuthenticationStatus.LOGGING_OUT) {
    return (
      <div className="h-screen overflow-hidden">
        <LinkInterceptor 
          globalRedirects={redirectConfig.exact}
          redirectRules={redirectConfig.rules}
        >
          <StreamContainer>
            <AppRouter />
            <ConnectDialog />
            <OtpDialog />
            <ConfirmModal />
            <HouseRulesModal />
          </StreamContainer>
        </LinkInterceptor>
      </div>
    );
  }
  else {
    return <div className="h-screen">
      <Loader />
    </div>;
  }
};

export default App;
